import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Bannersection from '../homepage/Bannersection';
import AbouttheCompany from '../homepage/AbouttheCompany';
import MyServicesection from '../homepage/MyServicesection';
import Howwork from '../homepage/Howwork';
import Quotes from '../homepage/Quotes';


import Ourindustryswiper from '../homepage/Ourindustryswiper';

function Home() {
  return (
    <div>
        <Header/>
    <Bannersection/>
    <AbouttheCompany/>
<MyServicesection/>

<Ourindustryswiper/>
   <Howwork/>
   <Quotes/>

      <Footer/>
    </div>
  )
}

export default Home;
